import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DateObject } from 'react-multi-date-picker';

type Props = {
  value: DateObject[];
  onlyMonthPicker?: boolean | undefined;
  position?: string;
};

export const CustomHeader: React.FC<Props> = ({ value, onlyMonthPicker }) => {
  const { t } = useTranslation();

  const dayStart = value?.[0]?.day;
  const monthStart = value?.[0]?.month?.shortName;
  let monthStartName = '';

  if (monthStart) {
    monthStartName = t(`common:calendar.months.${monthStart.toLowerCase()}`);
  }

  const dayEnd = value?.[1]?.day;
  const monthEnd = value?.[1]?.month?.shortName;
  let monthEndName = '';

  if (monthEnd) {
    monthEndName = t(`common:calendar.months.${monthEnd?.toLowerCase()}`);
  }

  const yearStart = value?.[0]?.year;
  const yearEnd = value?.[1]?.year;

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        justifyContent: 'start',
        pt: 2,
        pl: 2,
      }}>
      <Typography
        sx={{
          color: 'text.disabled',
          fontWeight: '600',
          fontSize: '11px',
          mb: 1.5,
        }}>
        {t('common:calendar.selectDateRange').toUpperCase()}
      </Typography>

      <Typography
        variant="body2"
        sx={{
          fontWeight: '600',
        }}>
        {monthStartName
          ? `${monthStartName} ${onlyMonthPicker ? yearStart : dayStart}${monthEndName && ` - ${monthEndName} ${onlyMonthPicker ? yearEnd : dayEnd}`}`
          : ''}
      </Typography>
    </Box>
  );
};
